import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

/////
import { Logout } from "../../../../redux/featuer/user/userSlice";



import PageChange from "../../../pageChange/index";


export default function LogOut() {
    const isDataLoad = false;

    ///
    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(Logout());
        setTimeout(() => {
            window.location.href = "/";
        }, 500);
    }, [dispatch]);

    return (
        <>
            {isDataLoad ? (
                <>
                    <div></div>
                </>
            ) : (
                <PageChange />
            )}
        </>
    );
}
